import { Modal } from '@spotify-internal/anchor-ds';
import classnames from 'classnames';
import { TFunction, useT } from 'client/i18n/hooks/useT';
import React from 'react';
import { Icon } from '../../../../shared/Icon';
import Pressable from '../../../../shared/Pressable';
import { Statesman } from '../../../../shared/Statesman';
import { copyTextToClipboard } from '../../../../utils';
// @ts-ignore - missing type defs, but not necessary to create them since~ we're moving away from sass/css modules
import styles from '../RecordScene.sass';

interface RecordingNotSupportedProps {
  headingText: string;
  bodyText: string;
  onDidPressCopyLink: any;
  link: string;
  onComponentDidMount: any;
  labelledById?: string;
}

class RecordingNotSupportedClass extends React.Component<
  RecordingNotSupportedProps & { t: TFunction },
  any
> {
  private container = React.createRef<HTMLDivElement>();

  public componentDidMount() {
    const { onComponentDidMount } = this.props;
    onComponentDidMount();
  }

  public render() {
    const {
      headingText,
      bodyText,
      onDidPressCopyLink,
      link,
      labelledById,
      t,
    } = this.props;

    return (
      <div className={styles.disabledRecording} ref={this.container}>
        <Modal.Title className={styles.heading} id={labelledById}>
          {headingText}
        </Modal.Title>
        <Modal.Subtitle className={styles.copy}>{bodyText}</Modal.Subtitle>
        <Modal.Body
          as="div"
          style={{
            marginTop: '16px',
          }}
        >
          <ul className={styles.bullets}>
            <li className={styles.bullet}>
              <Statesman initialState={{ isShowingCopyConfirmation: false }}>
                {({ isShowingCopyConfirmation }, setState) => {
                  const hideCopyConfirmation = () =>
                    setState(() => ({
                      isShowingCopyConfirmation: false,
                    }));
                  const showCopyConfirmation = () =>
                    setState(() => ({
                      isShowingCopyConfirmation: true,
                    }));
                  return (
                    <Pressable
                      onPress={() => {
                        copyTextToClipboard(link);
                        onDidPressCopyLink();
                        showCopyConfirmation();
                        setTimeout(() => {
                          hideCopyConfirmation();
                        }, 2000);
                      }}
                    >
                      {({ isPressed }) => (
                        <>
                          <span className={styles.circle}>
                            <strong className={styles.numeral}>1</strong>
                          </span>
                          <span
                            className={classnames(
                              styles.bulletCopy,
                              styles.bold
                            )}
                          >
                            {isShowingCopyConfirmation
                              ? t(
                                  'VoiceMessageCreationModalScreen.RecordingNotSupported.LinkCopiedText',
                                  'Copied!',
                                  'Link copied text'
                                )
                              : t(
                                  'VoiceMessageCreationModalScreen.RecordingNotSupported.CopyLinkStep',
                                  'Tap here to copy link',
                                  'Send voice message instructions, copy link step'
                                )}
                            <span className={styles.icon}>
                              <Icon type="link" />
                            </span>
                          </span>
                        </>
                      )}
                    </Pressable>
                  );
                }}
              </Statesman>
            </li>
            <li className={styles.bullet}>
              <span className={styles.circle}>
                <strong className={styles.numeral}>2</strong>
              </span>
              <span className={styles.bulletCopy}>
                {t(
                  'VoiceMessageCreationModalScreen.RecordingNotSupported.OpenSafariStep',
                  'Open Safari',
                  'Send voice message instructions, open safari step'
                )}
              </span>
            </li>
            <li className={styles.bullet}>
              <span className={styles.circle}>
                <strong className={styles.numeral}>3</strong>
              </span>
              <span className={styles.bulletCopy}>
                {t(
                  'VoiceMessageCreationModalScreen.RecordingNotSupported.PasteLinkStep',
                  'Paste Link',
                  'Send voice message instructions, paste copied link step'
                )}
              </span>
            </li>
          </ul>
          <div className={styles.tapSafariContainer}>
            <p className={styles.tapSafariCopy}>
              {t(
                'VoiceMessageCreationModalScreen.RecordingNotSupported.SafariShortcutMessage',
                '(Or, if you see a Safari button here, just tap that instead!)',
                'Send voice message instructions, safari button shortcut message'
              )}
            </p>
            <div className={styles.arrowContainer}>
              <Icon type="SafariArrow" />
            </div>
          </div>
        </Modal.Body>
      </div>
    );
  }
}

export function RecordingNotSupported(props: RecordingNotSupportedProps) {
  const t = useT();
  return <RecordingNotSupportedClass {...props} t={t} />;
}
